import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router';

import { CallPage } from '../../../../../../pages/call';
import type { ErrorPageType } from '../../../../../components/error-page/types';
import { selectIsTelemessengerExpEnabled } from '../../../../flags/selectors';

interface OnlyCallsViewProps {
    errorPageType: ErrorPageType | null;
}

export const OnlyCallsView: FunctionComponent<OnlyCallsViewProps> = ({ errorPageType }) => {
    const isTelemessengerExpEnabled = useSelector(selectIsTelemessengerExpEnabled);

    if (errorPageType) {
        return null;
    }

    return (
        <Routes>
            <Route path="/j/:id" element={<CallPage />} />
            {isTelemessengerExpEnabled ? <Route path="/private-join/:id" element={<CallPage />} /> : <></>}
        </Routes>
    );
};
